import { render, staticRenderFns } from "./DetailsVouchers.vue?vue&type=template&id=475c59ae"
import script from "./DetailsVouchers.vue?vue&type=script&lang=js"
export * from "./DetailsVouchers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports